import styled from '@emotion/styled';
import { Button, colors } from '@smartsheet/lodestar-core';

export const IconButtonNoSpacing = styled(Button)`
  &&& {
    padding: 0;
    margin: 0;
    height: auto;
    color: ${props => props.color ?? colors.neutralDark40};
  }
  :hover {
    background: none;
  }
  &&:before {
    content: none;
  }
`;
